module.exports = __webpack_public_path__ + "img/kachel-einzelneprodukte_PRO12.cc470e98.png";